import React from "react";
import { useEffect, useState } from 'react';
import { Button, Col, Row, Container, Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { ProgressBar, getWizardSteps } from 'components/JobApplication/Shared/Helpers';
import StepOne from "components/JobApplication/Steps/StepOne"
import StepTwo from "components/JobApplication/Steps/StepTwo"
import StepThree from "components/JobApplication/Steps/StepThree"
import StepFour from "components/JobApplication/Steps/StepFour"
import StepFive from "components/JobApplication/Steps/StepFive"
import StepSix from "components/JobApplication/Steps/StepSix"
import StepSeven from "components/JobApplication/Steps/StepSeven"
import StepEight from "components/JobApplication/Steps/EqualOpportunitiesMonitoring" // stepEight
import ErrorPage from "components/JobApplication/Shared/ErrorPage"
import { getToken } from '../../utils/tokenUtils'; // Update the path accordingly
function JobApplicationWizard(props) {

    const [step, setStep] = useState(1);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [jodData, setJobData] = useState({});
    const [hasError, setHasError] = useState(false);
    const { id } = useParams(); // JOB ID Passed down
    const wizardSteps = getWizardSteps(jodData);

    // ### DATA FETCHES ##
    //const fetchJobInformation = async () => {
    //    try {
    //        let url = `FPMCareers/api/jobapplication/getJobData?jobId=${id}`
    //        const response = await fetch(url);
    //        const body = await response.json();
    //        setJobData(body);
    //    } catch (err) {
    //        console.log(err);
    //    }
    //};

    const fetchJobInformation = async () => {
        try {

            let url = `/fpmcareers/jobapplication/getJobData?jobId=${id}`;

            if (process.env.NODE_ENV === 'development') {
                url = `/jobapplication/getJobData?jobId=${id}`;
            }


            const token = getToken();
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                setHasError(true);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const body = await response.json();
            setJobData(body);
        } catch (err) {
            console.log(err);
            setHasError(true);
            // handle the error here, e.g. show an error message to the user
        }
    };


    const [applicationData, setApplicationData] = useState({
        jobApplicantsDetail: {},
        jobApplicantsWorkHistory: [],
        jobApplicantsEducation: [],
        jobApplicantsOtherQualifications: [],
        jobApplicantsReferees: [],
        jobApplicantDocuments: {},
        equalOpportunitiesDetails: {},
        signedName: ''
    });

    function mapReligionID(religionID) {
        if (!religionID) {
            return 0; 
        } else if (religionID.toLowerCase() === 'catholic') {
            return 1;
        } else if (religionID.toLowerCase() === 'protestant') {
            return 2; 
        } else if (religionID.toLowerCase() === 'neither') {
            return 3;
        }
        return 0; 
    }

    const handleSubmit = async (equalData) => {
        try {

            // submit
            setSaving(true);

            console.log(equalData);

            delete applicationData.jobApplicantsDetail.savedData; // not needed for controller

            const createApplicantsViewModel = {
                JobApplicantsDetailsViewModel: {
                    ...applicationData.jobApplicantsDetail,
                    JobId: id,
                    // data from equal opp form but saving to details 
                    DOB: equalData.DOB,
                    ReligionID: mapReligionID(equalData.ReligionID),
                },
                ListAppJobApplicantsWorkHistory: applicationData.jobApplicantsWorkHistory,
                ListAppJobApplicantsEducation: applicationData.jobApplicantsEducation,
                ListAppJobApplicantsOtherQualifications: applicationData.jobApplicantsOtherQualifications,
                ListAppJobApplicantsReferees: applicationData.jobApplicantsReferees,
                ListJobApplicantDocumentViewModel: applicationData.jobApplicantDocuments,
                JobApplicantsEqualOpportunities: equalData
            };

            let url = '/fpmcareers/jobapplication/submitApplication';

            if (process.env.NODE_ENV === 'development') {
                url = `/jobapplication/submitApplication`;
            }


            const token = getToken();
            const response = await fetch(url, {
                method: 'post',
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(createApplicantsViewModel),
            });

            if (response.ok) {
                setSaved(true);
                setSaving(false);
            } else {
                // error
                setSaving(false);
            }

        } catch (error) {
            setSaving(false);
            console.log(error);
        }
    }

    const handleNext = async (data) => {
        try {

            // pass the saved data to the applicationData array
            switch (step) {
                case 1:
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        jobApplicantsDetail: {
                            ...data,
                            // this keeps values from step5 if the user entered data 
                            AdjusmentWhenAttendingInterview: data.adjusmentWhenAttendingInterview ?? prevState.jobApplicantsDetail.AdjusmentWhenAttendingInterview,
                            OtherInformation: data.otherInformation ?? prevState.jobApplicantsDetail.OtherInformation,
                        },
                    }));
                    break;
                case 2:
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        jobApplicantsWorkHistory: data,
                    }));
                    break;
                case 3:
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        jobApplicantsEducation: data,
                    }));
                    break;
                case 4:
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        jobApplicantsOtherQualifications: data,
                    }));
                    break;
                case 5:
                    // updating two values withn the jobApplicantsDetail
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        jobApplicantsDetail: {
                            ...prevState.jobApplicantsDetail,
                            AdjusmentWhenAttendingInterview: data.adjusmentWhenAttendingInterview ?? null,
                            OtherInformation: data.otherInformation ?? null,
                        },
                        jobApplicantDocuments: data.cvFile
                    }));
                    break;
                case 6:
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        jobApplicantsReferees: data,
                    }));
                    break;
                case 7:
                    await setApplicationData((prevState) => ({
                        ...prevState,
                        signedName: data,
                    }));
                    break;
                default:
                    break;
            }
            setStep((prevStep) => prevStep + 1); // ADD ONE STEP
        } catch (error) {
            console.error(error);
        }
    };

    const handleBack = async (data) => {

        if (jodData.jobType === 'Operational' && step === 4) {
            setStep(step - 2); // go back two steps to StepTwo
        } else {
            setStep(step - 1);
        }


        // hold the last page when going backwards
        if (jodData.jobType === 'Operational' && step === 8) {
            await setApplicationData((prevState) => ({
                ...prevState,
                equalOpportunitiesDetails: data,
            }));
        }

        if (jodData.jobType === 'Staff' && step === 8) {
            await setApplicationData((prevState) => ({
                ...prevState,
                equalOpportunitiesDetails: data,
            }));
        }
    };

    const renderStep = () => {
        switch (step) {
            case 1:
                return <StepOne handleNext={handleNext} storedData={applicationData.jobApplicantsDetail} role={jodData.jobReference} />;
            case 2:
                return <StepTwo handleNext={handleNext} handleBack={handleBack} storedData={applicationData.jobApplicantsWorkHistory} />;
            case 3:
                if (jodData.jobType === 'Operational') {
                    // Skip StepThree for 'Operational' job type
                    setStep((prevStep) => prevStep + 1); 
                }
                return <StepThree handleNext={handleNext} handleBack={handleBack} storedData={applicationData.jobApplicantsEducation} />;
            case 4:
                return <StepFour handleNext={handleNext} handleBack={handleBack} storedData={applicationData.jobApplicantsOtherQualifications} stepNum={jodData.jobType === 'Operational' ? '3.' : '4.'} jobType={jodData.jobType} />;
            case 5:
                return <StepFive handleNext={handleNext} handleBack={handleBack} storedData={{
                    adjusmentWhenAttendingInterview: applicationData.jobApplicantsDetail?.AdjusmentWhenAttendingInterview,
                    otherInformation: applicationData.jobApplicantsDetail?.OtherInformation,
                    cvFile: applicationData?.jobApplicantDocuments
                }}
                    stepNum={jodData.jobType === 'Operational' ? '4.' : '5.'} jobType={jodData.jobType}/>;
            case 6:
                return <StepSix handleNext={handleNext} handleBack={handleBack} storedData={applicationData.jobApplicantsReferees} stepNum={jodData.jobType === 'Operational' ? '5.' : '6.'} jobType={jodData.jobType} />;
            case 7:
                return <StepSeven handleNext={handleNext} handleBack={handleBack} storedData={applicationData.signedName} stepNum={jodData.jobType === 'Operational' ? '6.' : '7.'} />;
            case 8:
                return <StepEight storedData={applicationData.equalOpportunitiesDetails}  handleSubmit={handleSubmit} handleBack={handleBack} stepNum={jodData.jobType === 'Operational' ? '7.' : '8.'} />;
            default:
                return null;
        }
    };

    const getProgress = () => {
        const totalSteps = 9;
        const progressPerStep = 100 / totalSteps;

        switch (step) {
            case 1:
                return progressPerStep;
            case 2:
                return progressPerStep * 2;
            case 3:
                return progressPerStep * 3;
            case 4:
                return progressPerStep * 4;
            case 5:
                return progressPerStep * 5;
            case 6:
                return progressPerStep * 6;
            case 7:
                return progressPerStep * 7;
            case 8:
                return progressPerStep * 8;
            case 9:
                return 100;
            default:
                return 0;
        }
    };


    useEffect(() => {
        console.log(applicationData);
    }, [applicationData]);


    useEffect(() => {
        fetchJobInformation();
    }, []);

    useEffect(() => {
        let timeoutId;

        if (jodData) {
            timeoutId = setTimeout(() => {
                setIsLoading(false);
            }, 500);
        } else {
            // Show error message page
            setIsLoading(false);
            setHasError(true);
        }

        return () => {
            // Clear the timeout if the effect is cleaned up before it expires
            clearTimeout(timeoutId);
        };
    }, [jodData]);


    //const wizardSteps = jodData.jobType === 'Operational' ?
    //    [
    //        { label: 'Vacancy Information', number: 1 },
    //        { label: 'Employment History', number: 2 },
    //        { label: 'Other Qualifications', number: 3 },
    //        { label: 'Other Information', number: 4 },
    //        { label: 'Referees', number: 5 },
    //        { label: 'Declaration', number: 6 },
    //        { label: 'Equal Opportunities Monitoring', number: 7 },]
    //    : [
    //        { label: 'Vacancy Information', number: 1 },
    //        { label: 'Employment History', number: 2 },
    //        { label: 'Education', number: 3 },
    //        { label: 'Other Qualifications', number: 4 },
    //        { label: 'Other Information', number: 5 },
    //        { label: 'Referees', number: 6 },
    //        { label: 'Declaration', number: 7 },
    //        { label: 'Equal Opportunities Monitoring', number: 8 },
    //    ];

    if (hasError) {
        return <ErrorPage />;
    }

    if (saved) {
        return (
            <Container fluid>
                <div className="saved-container">
                    <h2 className="saved-title">Application Submitted!</h2>
                    <p className="saved-text">
                        Thank you for submitting your application.
                        Our HR team has received your application and will review it in due course.
                        You will be contacted by us soon regarding the status of your application.
                    </p>
                    <Button className="saved-button" href="/FPMCareers">
                        View Other Jobs
                    </Button>
                </div>
            </Container>
        );
    }


    return (
        <Container fluid>
            {isLoading || saving ? (
                <div
                    className="text-center"
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    <Spinner
                        animation="border"
                        style={{
                            width: "200px",
                            height: "200px",
                            border: "9px solid #fff",
                            borderRadius: "50%",
                            borderTopColor: "#1abc9c",
                            fontSize: "60px",
                        }}
                    />
                    <h3>{saving ? 'Submitting Job Application, Please Wait...' : isLoading ? 'Loading Job Application...' : null}</h3>
                </div>

            ) : (
                <div className="wizard text-center">
                    <Col> <img src={require("assets/img/Logo1.png").default} alt="image" /></Col>
                    <h2>Application for Employee ({jodData.jobType})</h2>
                    <ProgressBar progress={getProgress()}> {/*{`${getProgress().toFixed()}%`}*/}  </ProgressBar>
                    <div className="wizard__steps text-center">
                        {wizardSteps.map((step, index) => (
                            <div key={index} className={`wizard__step ${step.completed ? 'completed' : ''} ${step.active ? 'active' : ''}`}>
                                <div className="wizard__step-label">{step.label}</div>
                                <div className="wizard__step-number">{step.completed ? '✓' : index + 1}</div>
                            </div> ))}
                    </div>
                    <div className="wizard__content">
                        {renderStep()}
                    </div>
                </div>
            )}
        </Container>
    );
}

export default JobApplicationWizard;
